module.exports = __webpack_public_path__ + "static/media/Fibra Whole Wheat.da7ce506.png";